module.exports = __webpack_public_path__ + "static/media/Phenikaa_3D.b753e79b.gltf";